import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05adacf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative tw-mt-4 lg:tw-pr-4 text-input" }
const _hoisted_2 = ["autocomplete", "type", "disabled", "data-status", "data-validation"]
const _hoisted_3 = {
  key: 1,
  class: "border-animation lg:tw-pr-4"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-text-xs tw-text-red-700 tw-mt-2"
}

import { PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedTextInput',
  props: /*#__PURE__*/_mergeModels({
  autocomplete: {
    type: String,
    required: false,
    default: null,
  },

  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },

  label: {
    type: String,
    required: true,
  },

  errors: {
    type: Array as PropType<Array<string>>,
    required: false,
  },

  required: {
    type: Boolean,
    required: false,
    default: false,
  },

  hideable: {
    type: Boolean,
    required: false,
    default: false,
  },
}, {
    "modelValue": {
  },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const { autocomplete, disabled, label, errors, required, hideable } = __props;

const [model, modifiers] = _useModel(__props, "modelValue", {
  set(value: string) {
    if (modifiers.nullify) return value || null;
    return value;
  },
});

const show = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
        autocomplete: __props.autocomplete,
        type: !__props.hideable ? 'text' : show.value ? 'text' : 'password',
        disabled: __props.disabled,
        "data-status": _unref(model) ? 'filled' : 'empty',
        "data-validation": __props.errors && __props.errors.length > 0 ? 'invalid' : 'valid',
        style: {"border-bottom":"2px solid lightgrey"},
        class: _normalizeClass([
          __props.errors && __props.errors.length > 0
            ? 'focus:tw-text-red-700 focus:tw-border-red-700 focus:tw-outline-none animate__animated animate__headShake'
            : 'focus:tw-text-gray-700 focus:tw-outline-none'
        , "form-control tw-border-b-2 tw-border-gray-500 tw-block tw-w-full tw-py-1.5 tw-text-base tw-font-normal tw-text-gray-700 tw-bg-transparent tw-bg-clip-padding tw-transition tw-ease-in-out tw-m-0"])
      }, null, 10, _hoisted_2), [
        [_vModelDynamic, _unref(model)]
      ]),
      _createElementVNode("label", {
        class: _normalizeClass(["floating-label", __props.errors && __props.errors.length > 0 ? 'tw-text-red-700' : 'tw-text-gray-700'])
      }, _toDisplayString(__props.required ? `${__props.label} *` : __props.label), 3),
      (__props.hideable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (show.value = !show.value)),
            class: "tw-absolute tw-right-2 tw-block tw-z-10 tw-top-2 tw-cursor-pointer"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(!show.value ? 'fas fa-eye' : 'fas fa-eye-slash')
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      (!__props.errors || __props.errors.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      appear: ""
    }, {
      default: _withCtx(() => [
        (__props.errors && __props.errors.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.errors[0]), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})